import { writable } from 'svelte/store';

const storage_view_width = localStorage.getItem("view_width");

export const view_width = writable(storage_view_width ? JSON.parse(storage_view_width) : {});

view_width.subscribe(value => {
    localStorage.setItem("view_width", JSON.stringify(value));
});